import api from '../../../App/socket';

export const getPriceOMConfig = () => api.send({
    api: 'db',
    model: 'Priceomatic_configuration',
    action: 'Read',
    options: {
        attributes: 'all',
        limit: 1,
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic_update/requests/get_priceom_config_request.js